$.Fotorama.measures = {};